import React, { useState } from "react";
import Fuse from "fuse.js";
import TesteBusca from "./Pages/TesteBusca";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Footer from "./Footer";
import "../main.css";

function ResultadoPesquisa() {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showTesteBusca, setShowTesteBusca] = useState(false);
  const data = require("../data.json");

  const fuseOptions = {
    keys: ["titulo", "descricao"],
    includeScore: true,
  };

  const fuse = new Fuse(data, fuseOptions);

  const handleSearch = () => {
    const results = fuse.search(searchTerm);
    setSearchResults(results);
    setShowTesteBusca(true);
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <>
      <section className="jumbotron jumbotron-fluid text-center">
        <div
          className="navbar navbar-dark navbar-static-top navbar-expand-lg"
          role="navbar"
        >
          <a href="/" className="navbar-brand">
            <img className="logo" src="img/logo-salesbox2.svg" alt="logo" />
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarText"
            aria-controls="navbarText"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
        </div>

        <div className="cover"></div>

        <div className="container">
          <h1 className="jumbotron-heading">Olá, estamos aqui para te ajudar!</h1>

          <div className="row justify-content-center text-center">
            <div className="col-md-10">
              <form
                id="searchForm"
                className="search-form"
                onSubmit={(event) => {
                  event.preventDefault(); // Impede a submissão padrão do formulário
                }}
              >
                <div className="input-group search">
                  <input
                    type="text"
                    name="q"
                    value={searchTerm}
                    onChange={handleInputChange}
                    className="search-field"
                    aria-label="Search field"
                    placeholder="Digite aqui sua dúvida..."
                    aria-required="true"
                    required
                    autoComplete="off"
                  />
                  <button
                    className="input-group-addon"
                    type="submit"
                    onClick={handleSearch}
                  >
                    <i className="fa fa-search">&nbsp;</i>
                    <FontAwesomeIcon icon={faSearch} color="grey" />
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      {showTesteBusca ? (
        <>
          <TesteBusca searchResults={searchResults} />
          <br></br>
          <Footer />
        </>
      ) : (
        <>
          <Footer />
        </>
      )}
    </>
  );
}

export default ResultadoPesquisa;
